module.exports = __webpack_public_path__ + "img/bitkeep_s.09f024e2.png";